import { maxBreakpoints, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';
var spacing = theme.spacing;
export var nav = /*#__PURE__*/css(["display:none;", ";"], mediaQuery({
  min: minBreakpoints.L
}, css(["display:block;padding:0 ", ";border-bottom:1px solid var(--neutral-black-30);"], pxToRem(spacing.xl))));

/* used in static HTML to occupy empty space ready for client render of nav */
export var placeholder = /*#__PURE__*/css(["", ";", ";"], mediaQuery({
  min: minBreakpoints.L,
  max: maxBreakpoints.L
}, css(["min-height:43px;"])), mediaQuery({
  min: minBreakpoints.XL
}, css(["min-height:47px;"])));
export var list = /*#__PURE__*/css(["list-style-type:none;max-width:", ";display:flex;margin:0 auto;padding:0;justify-content:center;"], pxToRem(minBreakpoints.XL));